import clients from "./clients/phase3_clients";
import actionLists from "./actionLists/phase3_actionLists";
import discounts from "./discounts/phase3_discounts";
import salesOrders from "./salesOrders/phase3_salesOrders";
import specials from "./specials/phase3_specials";

export default {
  modules: {
    clients,
    actionLists,
    discounts,
    salesOrders,
    specials,
  },
};
